import constants from "../constants";

export default {
  /* Navigation */
  setNavigationTabs: (state, tabs) => (state.navigation.tabs = tabs),
  setNavigationTabIndex: (state, tabIndex) =>
    (state.navigation.activeTabIndex = tabIndex),
  /* Date filter */
  setDateFilterStartDate: (state, startDate) =>
    (state.data.filter.startDate = startDate),
  setDateFilterEndDate: (state, endDate) =>
    (state.data.filter.endDate = endDate),
  setDataCurrentDate: (state, currentDate) =>
    (state.data.currentDate = currentDate),
  /* Maps */
  setMapBounds: (state, bounds) => (state.map.bounds = bounds),
  setMapDataUpdate: (state, update) => (state.map.data.update = update),
  /* Events */
  setDataEventsCollectionFeatures: (state, featureCollection) => {
    //TODO: Merge event data with map data.
    state.data.events.geojson = featureCollection;
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_EVENT_ID,
      featureCollection: featureCollection
    });
  },
  setDataEventsSelectedIndex: (state, selectedEventIndex) =>
    (state.data.events.selectedEventIndex = selectedEventIndex),
  setDataEventsSelected: (state, selectedEvent) => {
    // Check for empty object.
    // Note that:  if (selectedEvent === {} ) { // Does not work. }
    if (Object.entries(selectedEvent).length === 0) {
      state.data.events.selectedEventIndex = null;
      return;
    }
    const features = state.data.events.geojson.features;
    for (var i = 0; i < features.length; i++) {
      if (selectedEvent.properties.id === features[i].properties.id) {
        state.data.events.selectedEventIndex = i;
        break;
      }
    }
  },
  /* Weather */
  setDataWeatherTimeSeries: (state, weather) =>
    (state.data.weather.timeseries = weather),
  setDataCurrentWeather: (state, { temperature, icon }) => {
    state.data.weather.current.temperature = temperature;
    state.data.weather.current.icon = icon;
  },
  /* Parking */
  setParkingChartData: (state, payload) => {
    state.data.parking.datasets[payload.entityId] = payload.chartData;
  },
  setDataParkingCollectionFeatures: (state, featureCollection) => {
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_PARKING_ID,
      featureCollection: featureCollection
    });
  },
  setDataParkingTimeSeries: (state, timeseries) =>
    (state.data.parking.timeseries = timeseries),
  setMapDataParkingOnDate: (state, payload) => {
    let layerId = constants.MAP_LAYER_PARKING_ID;
    let layer = state.map.data.layers.find(l => l.id === layerId);
    let tsIndex = state.data.parking.timeseries.labels.indexOf(payload.onDate);
    const keys = Object.keys(state.data.parking.datasets);
    let features = [];
    for (let i = 0; i < keys.length; i++) {
      // Copy existing feature to retain the properties en geometry.
      let feature = {
        ...layer.source.data.features.find(
          f => f.properties.entityId === keys[i]
        )
      };
      if (!feature.properties) {
        // console.log(`No feature properties`);
        feature.properties = {};
      }
      feature.properties.availableSpots = feature.properties.totalSpots;
      feature.properties.occupiedSpots = 0;
      feature.properties.occupiedPercentage = 0;
      // Update the features properties.
      let datasets = state.data.parking.datasets[keys[i]].datasets;
      if (datasets && datasets[0].data.length > tsIndex) {
        feature.properties.availableSpots = datasets[0].data[tsIndex];
        feature.properties.occupiedSpots =
          feature.properties.totalSpots - datasets[0].data[tsIndex];
        feature.properties.occupiedPercentage = Math.round(
          ((feature.properties.totalSpots - feature.properties.availableSpots) /
            feature.properties.totalSpots) *
            100
        );
      }
      // Push to the features array which will populate the feature collection.
      features.push(feature);
    }
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_PARKING_ID,
      featureCollection: {
        type: "FeatureCollection",
        features: features
      }
    });
    //HACK: Flip the update bit to refresh map.
    state.map.data.update = true;
  },
  /* Travel Time */
  setTravelTimeTimeSeries: (state, travelTimeTimeSeries) => {
    state.data.traveltime.timeseries = travelTimeTimeSeries;
  },
  setTravelTime: (state, travelTime) => {
    let mapping = constants.TRAVELTIME_SHAPES_MAPPING;
    if (mapping[travelTime.urn]) {
      let layer = findLayer(state, { layerId: constants.MAP_LAYER_TRAVEL_ID });
      if (layer) {
        for (let i = 0, len = layer.source.data.features.length; i < len; i++) {
          let feature = layer.source.data.features[i];
          for (let j = 0, len = mapping[travelTime.urn].length; j < len; j++) {
            if (feature.properties.wvk_id == mapping[travelTime.urn][j]) {
              feature.properties.relativeDelay = travelTime.relativeDelay;
            }
          }
        }
      }
    }
  },
  setTravelIntensityTimeSeries: (state, trafficIntensity) => {
    state.data.travelintensity.timeseries = trafficIntensity;
  },
  setDataTrafficIntensityTimeseries: (state, trafficIntensity) => {
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_TRAFFIC_ID,
      featureCollection: trafficIntensity
    });
  },
  /* Trackers */
  setDataTrackerHeatmapCollectionFeatures: (state, featureCollection) => {
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_TRACKERS_HEATMAP_ID,
      featureCollection: featureCollection
    });
  },
  /* Antea */
  setAnteaData: (state, payload) => {
    state.data.antea = payload;
  },

  setDataTrackerRoutesCollectionFeatures: (state, featureCollections) => {
    state.pager.trackerroutes.data = featureCollections;
    let layerId = constants.MAP_LAYER_TRACKERS_ROUTES_ID;
    let controlLayer = findLayerControl(state, { layerId });
    if (controlLayer) {
      controlLayer.pager.current = 1;
      state.pager[layerId].selectedIndex = 0;
      controlLayer.pager.max = featureCollections.length;
    }

    let layerIndex = findLayerIndex(state, { layerId });
    if (layerIndex >= 0) {
      state.map.data.layers[layerIndex].source.data =
        state.pager.trackerroutes.data[state.pager[layerId].selectedIndex];
    }
  },
  setLayerSelectPagerPrevious: (state, layerId) => {
    let controlLayer = findLayerControl(state, { layerId });
    if (controlLayer) {
      if (controlLayer.pager.current == 1) {
        controlLayer.pager.current = controlLayer.pager.max;
      } else {
        controlLayer.pager.current--;
      }
      if (state.pager[layerId]) {
        state.pager[layerId].selectedIndex = controlLayer.pager.current - 1;
      }
    }

    let layerIndex = findLayerIndex(state, { layerId });
    if (layerIndex >= 0) {
      state.map.data.layers[layerIndex].source.data =
        state.pager.trackerroutes.data[state.pager[layerId].selectedIndex];
    }
    state.map.data.update = true;
  },
  setLayerSelectPagerNext: (state, layerId) => {
    let controlLayer = findLayerControl(state, { layerId });
    if (controlLayer) {
      if (controlLayer.pager.current == controlLayer.pager.max) {
        controlLayer.pager.current = 1;
      } else {
        controlLayer.pager.current++;
      }
      if (state.pager[layerId]) {
        state.pager[layerId].selectedIndex = controlLayer.pager.current - 1;
      }
    }

    let layerIndex = findLayerIndex(state, { layerId });
    if (layerIndex >= 0) {
      state.map.data.layers[layerIndex].source.data =
        state.pager.trackerroutes.data[state.pager[layerId].selectedIndex];
    }
    state.map.data.update = true;
  },
  setDataTrackerLikes: (state, likes) => {
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_TRACKERS_LIKES,
      featureCollection: likes
    });
  },
  clearDataTracker: state => {
    // Should clear heatmap, routes and likes.
    const emptyFeatureCollection = {
      type: "FeatureCollection",
      features: []
    };
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_TRACKERS_HEATMAP_ID,
      featureCollection: emptyFeatureCollection
    });
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_TRACKERS_ROUTES_ID,
      featureCollection: emptyFeatureCollection
    });
    setDataFeatureCollection(state, {
      layerId: constants.MAP_LAYER_TRACKERS_LIKES,
      featureCollection: emptyFeatureCollection
    });
  },
  /* Presets */
  setPresets: (state, presets) => {
    state.data.presets.system = presets;
  },
  setUserPresets: (state, presets) => {
    state.data.presets.user = presets;
  },
  setPresetActivePreset: (state, preset) => {
    let presets = { ...state.data.presets };

    for (let i = 0, len = presets.system.length; i < len; i++) {
      presets.system[i].active = false;
      if (presets.system[i].id === preset.id) {
        presets.system[i].active = true;
      }
    }
    for (let i = 0, len = presets.user.length; i < len; i++) {
      presets.user[i].active = false;
      if (presets.user[i].id === preset.id) {
        presets.user[i].active = true;
      }
    }
    state.data.presets = presets;
  },
  clearPresetActivePreset: state => {
    let presets = { ...state.data.presets };
    presets.system.map(preset => (preset.active = false));
    presets.user.map(preset => (preset.active = false));
    state.data.presets = presets;
  },
  /* Experience sampling */
  setDataMetricWireSurveys: (state, surveys) => {
    state.data.metricwire.surveys = surveys;
  },
  setDataMetricWireSelectedSurvey: (state, survey) => {
    state.data.metricwire.selectedSurvey = survey;
  },
  setDataMetricWireSurveyCategories: (state, categories) => {
    state.data.metricwire.surveyCategories = categories;
  },
  /* VR survey */
  setExperienceSamplingWorkspaceId: (state, { workspaceId }) => {
    state.data.experienceSampling.workspace.id = workspaceId;
  },
  setExperienceSamplingStudies: (state, studies) => {
    state.data.experienceSampling.workspace.studies = studies;
  },
  setExperienceSamplingSelectedStudyId: (state, { studyId }) => {
    state.data.experienceSampling.workspace.selectedStudy.id = studyId;
  },
  setExperienceSamplingSurveys: (state, surveys) => {
    state.data.experienceSampling.workspace.selectedStudy.surveys = surveys;
  },
  setExperienceSamplingSelectedSurvey: (state, { surveyId }) => {
    state.data.experienceSampling.workspace.selectedStudy.selectedSurvey.id = surveyId;
  },
  setExperienceSamplingQuestions: (state, questions) => {
    state.data.experienceSampling.workspace.selectedStudy.selectedSurvey.questions = questions;
  },
  setExperienceSamplingSurveyChart: (state, chart) => {
    state.data.experienceSampling.chart = {
      labels: chart.labels,
      datasets: [
        {
          label: chart.name,
          backgroundColor: "rgba(34, 208, 178, 0.8)",
          data: chart.data
        }
      ]
    };
  },
  setExperienceSamplingSelectedQuestion: (state, { questionId }) => {
    state.data.experienceSampling.workspace.selectedStudy.selectedSurvey.selectedQuestion = questionId;
  }
};

function findLayerControl(state, { layerId }) {
  const layers = state.map.controls.layers;
  for (var i = 0; i < layers.length; i++) {
    if (layers[i].id === layerId) {
      return layers[i];
    }
    // Search in sub layers as well
    if (layers[i].items && layers[i].items.length > 0) {
      for (var j = 0; j < layers[i].items.length; j++) {
        if (layers[i].items[j].id === layerId) {
          return layers[i].items[j];
        }
      }
    }
  }
}
function findLayerIndex(state, { layerId }) {
  const layers = state.map.data.layers;
  for (var i = 0; i < layers.length; i++) {
    if (layers[i].id === layerId) {
      return i;
    }
  }
  return -1;
}
function findLayer(state, { layerId }) {
  let index = findLayerIndex(state, { layerId: layerId });
  if (index < 0) {
    return {};
  } else {
    return state.map.data.layers[index];
  }
}

function setDataFeatureCollection(state, { layerId, featureCollection }) {
  let layer = findLayer(state, { layerId });
  if (layer) {
    layer.source.data = featureCollection;
  }
}
